var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticClass:"app-footer",attrs:{"height":"60","elevation":"15"}},[_c('div',{staticClass:"flex-grow-1"}),_c('div',[_vm._v("Copyright © 2026 Nobuaki Honda All Rights Reserved.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }